import React from "react"
import _ from "lodash"
import ImageHeader from "./ImageHeader"
import headerImage from "../assets/img/banners/Explore_Plan_Cover.jpg"
import AsyncElements from "./AsyncElements"
import ModuleCard from "./ModuleCard"
import ModuleNavbar from "./ModuleNavbar"
import ModuleSubpage from "./ModuleSubpage"
import "../assets/css/modules-container.css"

//importing related to onboarding guide
import { OnboardingGuideBanner } from "../components/OnboardingHomepage"
import { OnboardingTeacherContext } from "../contexts/OnboardingTeacherContextProvider"

const ModulesPage = props => {
  const {
    moduleProps: { collection, isFetching, fetchError },
    sequenceId,
    moduleId,
    handleSubpageSelect,
    crudAction,
    subpage
  } = props
  const currentModule = _.isEmpty(collection) ? {} : collection[moduleId] || {}
  const currentSequence = _.isEmpty(currentModule)
    ? {}
    : _.find(currentModule.sequences || [], sequence => sequence.id === sequenceId)

  const headerText = () => {
    switch (crudAction) {
      case "LIST":
        return (
          <span>
            <span className='semi-bold'>explore</span> &amp; assign
          </span>
        )
      case "SHOW":
        return currentModule.name || "..."
      default:
        return "..."
    }
  }

  // TODO: don't hardcode this, add a field to modules on
  // the CAT and use that ordering instead
  const getModules = () => {
    return _.compact([
      collection["3"],
      collection["5"],
      collection["2"],
      collection["1"],
      collection["6"],
      collection["10"],
      collection["11"]
    ])
  }

  //onboarding guide checks
  const { isAllComplete } = React.useContext(OnboardingTeacherContext)

  return (
    <ImageHeader
      image={headerImage}
      titleContents={headerText()}
      containerClass='modules-container'
    >
      <div className='col-lg-12'>
        {!isAllComplete && (
          <div style={{ marginBottom: "32px" }}>
            <OnboardingGuideBanner />
          </div>
        )}

        <AsyncElements isLoading={isFetching} fetchError={fetchError}>
          {crudAction === "LIST" && (
            <div className='row module-cards-row'>
              {_.map(getModules(), module => {
                return <ModuleCard key={module.id} title={module.name} id={module.id} />
              })}
            </div>
          )}
          {crudAction === "SHOW" && moduleId && (
            <div className='row'>
              <ModuleNavbar
                module={currentModule}
                currentSubpage={subpage}
                handleSubpageSelect={handleSubpageSelect}
              />
              <div className='col-md-8 col-sm-10'>
                <ModuleSubpage
                  subpageType={subpage}
                  module={currentModule}
                  sequence={currentSequence}
                />
              </div>
            </div>
          )}
        </AsyncElements>
      </div>
    </ImageHeader>
  )
}

export default ModulesPage
